import { createAsyncThunk } from '@reduxjs/toolkit'
import { projectAPIBuilder } from '../asyncActions/BoMAsyncActions'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveProjectReference = createAsyncThunk<any, any, { state: any }>(
  'project/saveProjectReference',
  async (projectReference: string, thunkAPI) => {
    const { projectId, api } = projectAPIBuilder(thunkAPI.getState)

    try {
      thunkAPI.dispatch(
        newProjectActions.setActiveProjectProperties({
          projectReference: projectReference,
        })
      )

      await api.SetProjectReference(projectId, projectReference)
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
